import React, { Component } from 'react';
import { BrowserRouter as Router, Link } from 'react-router-dom'
import QrReader from 'react-qr-reader'
import '../css/Scan.css';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import LocalizedStrings from 'react-localization';
import { data } from '../js/data.js';

let strings = new LocalizedStrings(data);

class Scan extends Component {

    state = {
        result: 'No result'
    }
     
    handleScan = data => {
        if (data) {
          this.setState({
            result: data
          })
        }
    }
    handleError = err => {
        console.error(err)
    }
    render() {
        strings.setLanguage(this.props.languages);
        if(this.state.result == 'No result')
        return (
                <div >
                    <div>
                       
                    </div>
                    <div class="scan-window">
                        <h3>{strings.positionQR}</h3>
                        <QrReader
                        className="qr-reader"
                        delay={300}
                        onError={this.handleError}
                        onScan={this.handleScan}
                        style={{ width: '100%' }}
                        />
                    </div>
                    <div style={{marginTop:40}}>
                        <Link to="/currentlocation">
                            <Button class="btn-large btn-dir btn-red btn-moveup"
                                node="a"
                                waves="light"
                                large
                                style={{marginBottom: '10px'}}
                            >
                                {strings.manualEntry}
                            </Button>
                        </Link>
                    </div>
                </div>
            
        )
        else {
            window.location=this.state.result
        }
    }
}

const mapStateToProps = (state) => {
    return {
        maps: state.maps.maps,
        languages: state.language.language
    }
}

export default connect(mapStateToProps)(Scan);
